import React, { useEffect, useState } from "react";
import UserEngagement from "../UserEngagement/UserEngagement";
import SuccessStory from "../SuccessStory";
import Faq from "../Faq";
import { useDispatch, useSelector } from "react-redux";
import PersonaliseCard from "./PersonaliseCard";
import GetCertifiedCard from "./GetCertifiedCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import UploadCvLinkedin from "../UploadCvLinkedin/UploadCvLinkedin";
import { getLinkedInSuggestions } from "../../../redux/actions/certificateVerification";
import RadarChart from "../RadarChart";
import RolesQualified from "../RolesQualified";
import OwnerButton from "./OwnerButton";
import Constants from "../../../common/constants";
import { Mixpanel } from "../../../config/Mixpanel";
import { v4 as uuidv4 } from 'uuid';

const OwnerVariant = ({ openLinkedInLogin  ,uploadRef ,handlerCertified , handlerPersonalise , targetRef , loading}) => {
  const userDetails = useSelector(
    (store) => store?.certificateVerification?.userInfo
  );
  const [linkedinProfiles, setLinkedinProfiles] = useState([]);
  const certificateData = useSelector((store) => store?.certificateVerification?.certificateData);
  const certifiedData = useSelector((store)=>store?.certificateVerification?.certifiedData);
  const [isActive, setIsActive] = useState(false);
  const islocked = useSelector((store)=>store?.certificateVerification?.is_locked);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      getLinkedInSuggestions(
        userDetails?.email,
        (successObj) => {
          setLinkedinProfiles(successObj?.data);
        },
        (errorObj) => {}
      )
    );
  }, [dispatch, userDetails?.email]);

  useEffect(() => {
    // First run: remember initial state
    if(!loading){
     
      Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_OWNER_PAGE_LOADED);
  
    }
  }, [loading]);
  

  return (
    
    <div className="mt-6 relative w-full">
      <UserEngagement openLinkedInLogin={openLinkedInLogin} />

      <div className="mt-2" ref={targetRef}>
        <OwnerButton uploadRef={uploadRef} handlerCertified={handlerCertified} setIsActive={setIsActive}/>
      </div>
     {certificateData?.certificate_type!=="personalized" && <div className="mt-8">
        <div className="text-center text-[24px] md:text-[28px] font-medium leading-[130%] text-white px-4">
          Basis Quiz Analysis, Your{" "}
          <span className="text-[28px] md:text-[32px] font-bold text-[#00C1FF]">
            {" "}
            Top Strengths:{" "}
          </span>
        </div>
        <div className="mt-4">
          <RadarChart/>
        </div>
      </div>}
      <div className="mt-4">
        <div className="font-medium text-[16px] md:text-[20px] text-white text-center">Roles You <span className="font-bold text-[#00C1FF]"> Qualify </span> For:</div>
        <div className="mt-3">
          <RolesQualified/>
        </div>

      </div>
      <div className="mt-4 w-full" ref={uploadRef}>
        <UploadCvLinkedin
          linkedinProfiles={linkedinProfiles}
          setLinkedinProfiles={setLinkedinProfiles}
          isActive={isActive}
          setIsActive={setIsActive}
        />
      </div>

      <div
        className="mt-8 -ml-4 flex w-[calc(100%+30px)] flex-col items-center justify-start bg-[#4285F4]/80  py-6 px-4"
        style={{
          backgroundImage: `linear-gradient(to bottom, rgba(13, 36, 54, 1) 0%, rgba(13, 36, 54, 0.5) 100%)`,
        }}
      >
        <div className="text-center text-[24px] md:text-[28px] font-medium leading-[130%] text-white">
          {userDetails?.name?.split(" ")?.[0]}{" "},
          <span className="text-[28px] md:text-[32px] font-bold text-[#00C1FF]">
            {" "}
            3x Your Career Growth{" "}
          </span>{" "}
          With LearnTube!
        </div>
        <div className="mt-4 w-full">
          <PersonaliseCard handlerPersonalise={handlerPersonalise} handlerCertified={handlerCertified}/>
        </div>
        <div className="mt-4 w-full">
          <GetCertifiedCard handlerCertified={handlerCertified}/>
        </div>
      </div>
      <div className="mt-8">
        <SuccessStory />
      </div>
      <div
        className="mt-8 -ml-4 flex w-[calc(100%+30px)] flex-col items-center justify-start bg-[#4285F4]/80  py-6 px-4"
        style={{
          backgroundImage: `linear-gradient(to bottom, rgba(13, 36, 54, 1) 0%, rgba(13, 36, 54, 0.5) 100%)`,
        }}
      >
        <div className="text-center text-[24px] md:text-[28px] font-medium leading-[130%] text-white">
          Want To Qualify For Your{" "}
          <span className="text-[28px] md:text-[32px] font-bold text-[#00C1FF]">
            {" "}
            Dream Role{" "}
          </span>
          ?{" "}
        </div>
        <button className="mt-3 rounded-[8px] bg-[#7FC241] py-3 px-3 text-center text-[16px] md:h-[52px] md:text-[18px] font-medium text-[#121212]" onClick={(e)=>  { Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_OWNER_PAGE_BUILD_PERSONALIZED_COURSE_CLICKED); 
         if(!certifiedData?.is_paid){
          handlerPersonalise({utm_medium : 'build-course' , utm_source : 'certificate-verification'})
          console.log('run')
        }
        else{
          console.log('run1')
        handlerCertified({utm_medium : 'get-certified' , utm_source : 'certificate-verification'})

        }}
      }>
          Get A Personalised Path For 3x Growth
          <FontAwesomeIcon icon={faArrowRight} size="xl" className="ml-2" />
        </button>
      </div>
      {/* <div className="mt-8">
        <div className="mb-4 text-center text-[24px] md:text-[28px] font-medium text-white">
          Frequently{" "}
          <span className="text-[28px] md:text-[32px] font-bold text-[#00C1FF]"> Asked </span>{" "}
          Questions
        </div>
        <Faq />
      </div> */}
    </div>
  );
};

export default OwnerVariant;
